import { MappingProperty } from './mapping-property';
import { ApiText } from '@classes/api-text';

export class MappingBase {
    id: number;

    label: string;
    text?: ApiText;
    description?: string;
    mappingId?: number;

    validFrom?: Date;
    validTo?: Date;

    properties?: MappingProperty[];

    isSelected?: boolean;
    someSelected?: boolean;

    constructor(label: string, description: string) {
        this.label = label ? label.trim() : '';
        this.description = description ? description.trim() : '';
        // this.text.fullLabel = label ? label.trim() : '';
        // this.text.detail = description ? description.trim() : '';

        this.id = null;
    }
}
